// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3adz4","comment":"styles_comment__2z8cm"};